import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/lib/auth'

const EVENT_PATH = `${import.meta.env.VITE_API_BASE_URL ?? '/api'}/v1/events/stream`

export function LiveUpdates() {
  const { isAuthenticated } = useAuth()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!isAuthenticated) return
    const source = new EventSource(EVENT_PATH, { withCredentials: true })
    source.onmessage = (event) => {
      try {
        const body = JSON.parse(event.data) as { type?: string }
        if (
          body.type === 'order.changed' ||
          body.type === 'source.refreshed' ||
          body.type === 'extraction.changed' ||
          body.type === 'pnl.changed' ||
          body.type === 'transaction.changed' ||
          body.type === 'recon.changed' ||
          body.type === 'report.ready' ||
          body.type === 'alert.created' ||
          body.type === 'risk.changed'
        ) {
          void queryClient.invalidateQueries({ queryKey: ['overview'] })
          void queryClient.invalidateQueries({ queryKey: ['orders'] })
          void queryClient.invalidateQueries({ queryKey: ['freshness'] })
          void queryClient.invalidateQueries({ queryKey: ['counterparties'] })
          void queryClient.invalidateQueries({ queryKey: ['pnl'] })
          void queryClient.invalidateQueries({ queryKey: ['inventory'] })
          void queryClient.invalidateQueries({ queryKey: ['transactions'] })
          void queryClient.invalidateQueries({ queryKey: ['reconciliation'] })
          void queryClient.invalidateQueries({ queryKey: ['dashboard'] })
          void queryClient.invalidateQueries({ queryKey: ['reports'] })
          void queryClient.invalidateQueries({ queryKey: ['alerts'] })
          void queryClient.invalidateQueries({ queryKey: ['risk'] })
          void queryClient.invalidateQueries({ queryKey: ['accounts'] })
        }
        if (body.type === 'extraction.changed') {
          void queryClient.invalidateQueries({ queryKey: ['extraction'] })
        }
      } catch {
        // Некоректне повідомлення ігноруємо: наступне оновить стан.
      }
    }
    return () => source.close()
  }, [isAuthenticated, queryClient])

  return null
}
